import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faAmazon, faApple, faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';
import {
  faBookmark as faBookmarkLight,
  faCalculator,
  faCopy,
  faExchange,
  faHeart as faHeartLight,
  faMemo,
  faSignOutAlt,
  faSync,
  faTimes
} from '@fortawesome/pro-light-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBookmark,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faChevronCircleDown,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCirclePlay,
  faCity,
  faClone,
  faCompressArrowsAlt,
  faEdit,
  faExclamation,
  faExpandArrowsAlt,
  faFolder,
  faGear,
  faGraduationCap,
  faHeart,
  faHome,
  faInfoCircle,
  faLockAlt,
  faMinus,
  faPencilAlt,
  faPlus,
  faRedoAlt,
  faRefresh,
  faRotate,
  faRotateRight,
  faSave,
  faSchool,
  faSearch,
  faShareSquare,
  faSignInAlt,
  faTimes as faTimesSolid,
  faTrash,
  faUserGear,
  faUsers,
  faVideo
} from '@fortawesome/pro-solid-svg-icons';

@Injectable()
export class FontAwesomeIconRegistryService {
  private readonly iconNameToSourceMappings: { [iconName: string]: string } = {
    ['icon-owl-compare']: '/assets/images/roc-owl-compare.svg'
  };
  private isInitialized = false;

  public constructor(
    private library: FaIconLibrary,
    private faConfig: FaConfig,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  public init(): void {
    if (this.isInitialized) {
      return;
    }

    // config
    this.faConfig.defaultPrefix = 'fal';

    // brand icons
    this.library.addIcons(
      faFacebook,
      faGoogle,
      faAmazon,
      faApple,
      faBookmarkLight,
      faCopy,
      faHeartLight,
      faSignOutAlt,
      faSync,
      faTimes,
      faArrowLeft,
      faArrowRight,
      faBookmark,
      faCheck,
      faCheckCircle,
      faChevronCircleDown,
      faClone,
      faCompressArrowsAlt,
      faExclamation,
      faExclamationTriangle,
      faExpandArrowsAlt,
      faHeart,
      faHome,
      faInfoCircle,
      faLockAlt,
      faPencilAlt,
      faPlus,
      faFolder,
      faRedoAlt,
      faSearch,
      faShareSquare,
      faSignInAlt,
      faTimesSolid,
      faTrash,
      faCaretDown,
      faCaretUp,
      faExchange,
      faCalculator,
      faChevronLeft,
      faMinus,
      faEdit,
      faSave,
      faVideo,
      faCirclePlay,
      faChevronRight,
      faCity,
      faUsers,
      faSchool,
      faArrowUpRightFromSquare,
      faGraduationCap,
      faRotate,
      faArrowUp,
      faArrowDown,
      faUserGear,
      faGear,
      faChevronDown,
      faChevronUp,
      faRefresh,
      faMemo,
      faRotateRight
    );

    Object.keys(this.iconNameToSourceMappings).forEach(iconName => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(this.iconNameToSourceMappings[iconName])
      );
    });

    this.isInitialized = true;
  }
}
